<template
  ><v-card class="ma-0"  style="border-radius: 5px;">
    <v-row class="ma-0 pa-0">
      <v-col cols="12" class="info ma-0 " xl="4" lg="4" md="6" sm="12" xs="12" >
        <v-row class="ma-0 pa-0">
          <v-col cols="12" class="pa-0">
            <div
              class="d-flex justify-center align-center "
              style="position: relative; justify-content: center;"
            >
              <div style="margin: 0 auto;">
                <profileImage
                  :imageUrl="studentInfo.photoUrl"
                  :displayName="studentInfo.studentFullName"
                  :thumbnail="false" :showName="false"
                ></profileImage>
              </div>
              <v-btn
                v-if="isInRole('0')"
                :title="$t('edit')"
                icon
                @click="editDialog = true"
                :style="{
                  position: 'absolute',
                  top: '0',
                  [$i18n.locale === 'ar' ? 'right' : 'left']: '0'
                }"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col class="text-center" cols="12">
            <h3>{{ studentInfo.studentFullName ? studentInfo.studentFullName : "-" }}</h3>
            <p class="blue--text text--darken-3">
              {{ studentInfo.studentCode ? studentInfo.studentCode : "-" }}
            </p>
          </v-col>
          <v-col cols="12">

            <InfoSection
              title=''
              icon="mdi-email"
              v-if="studentInfo.email"
            >
              <template #default>
              <a
                :href="`mailto:${studentInfo.email}`"
                style="color: inherit; text-decoration: underline;"
                @click.stop
              >
                {{ studentInfo.email }}
              </a>
              </template>
            </InfoSection>
            <InfoSection
              v-else
              :title="'-'"
              icon="mdi-email"
            />
            <InfoSection
              :title="studentInfo.phoneNumber ? studentInfo.phoneNumber : '-'"
              icon="mdi-phone"
            />
            <InfoSection
              :title="
                studentInfo.stage && studentInfo.stage.stageName
                  ? studentInfo.stage.stageName + ' - ' + studentInfo.stage.studyType.studyName
                  : '-'
              "
              icon="mdi-school"
            />
            <InfoSection
              :title="studentInfo.stage ? studentInfo.stage.department.departmentsName : ''"
              icon="mdi-bank"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="8" lg="8" md="6" sm="12" xs="12">
        <v-row>
          <v-col class="pa-5" cols="12">
            <h4 style="text-decoration: underline;">{{ $t("portfolio.missionStatement") }}</h4>
            <div
              dir="auto"
              class="text-subtitle-2 d-flex flex-column gap-5 space-between"
              style="white-space: pre-line;"
            >
              {{ studentInfo.missionStatement ? studentInfo.missionStatement.trim() : "" }}
            </div>
          </v-col>
        </v-row>
        <v-row class="">
          <v-col class="pa-5 pt-0">
            <h4 style="text-decoration: underline;">{{ $t("portfolio.careerGoals") }}</h4>
            <div
              dir="auto"
              class="text-subtitle-2 d-flex flex-column gap-5 space-between"
              style="white-space: pre-line;"
            >
              {{ studentInfo.careerGoals ? studentInfo.careerGoals.trim() : "" }}
            </div>
          </v-col>
        </v-row>
        <v-row  >
          <v-col class="px-5" cols="12">
            <h4 style="text-decoration: underline;" class="pb-2">
              {{ $t("portfolio.summary.title") }}
            </h4>
            <span class="d-flex flex-row justify-space-between"> </span>
          </v-col>
          <v-col>
            <v-card rounded flat color="info" class="ma-2 pa-3 text-center">
              <v-icon size="36" class="mb-2" color="primary">mdi-file-document</v-icon>
              <div class="font-weight-bold">{{ $t("portfolio.summary.workSamples") }}</div>
              <div class="font-weight-bold">{{ worksStatus.workSampleCount }}</div>
            </v-card>
          </v-col>
          <v-col>
            <v-card rounded flat color="info" class="ma-2 pa-3 text-center">
              <v-icon size="36" class="mb-2" color="primary">mdi-trophy</v-icon>
              <div class="font-weight-bold">{{ $t("portfolio.summary.achievements") }}</div>
              <div class="font-weight-bold">{{ worksStatus.achievementCount }}</div>
            </v-card>
          </v-col>
          <v-col>
            <v-card rounded flat color="info" class="ma-2 pa-3 text-center">
              <v-icon size="36" class="mb-2" color="primary">mdi-bullseye</v-icon>
              <div class="font-weight-bold">{{ $t("portfolio.summary.goals") }}</div>
              <div class="font-weight-bold">{{ worksStatus.goalsCount }}</div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog
      v-model="editDialog"
      max-width="700px"
      min-width="500px"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title class="text-h5"
          >{{ $t("edit") }}
          <v-spacer></v-spacer>
          <v-btn icon @click="editDialog = false">
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div class="d-flex justify-center align-center" style="justify-content: center;">
                <profileImage
                  class="mb-4"
                  :imageUrl="studentInfo.photoUrl"
                  :displayName="studentInfo.studentFullName"
                  :thumbnail="false"
                  :showName="false"
                >
                </profileImage>
                <v-file-input
                  prepend-icon="mdi-camera"
                  accept="image/png, image/jpeg, image/jpg, image/bmp, image/gif"
                  @change="onPhotoSelected"
                  v-model="selectedPhotoFile"
                  :label="$t('profile.BrowsePictures')"
                >
                </v-file-input>
              </div>
              <v-text-field
                outlined
                v-model="studentInfo.email"
                :label="$t('Email')"
                type="email"
              ></v-text-field>
              <v-text-field
                outlined
                v-model="studentInfo.phoneNumber"
                :label="$t('MobileNumber')"
                type="tel"
              ></v-text-field>
              <v-textarea
                counter="1000"
                dir="auto"
                :rules="[v => v.length <= 1000]"
                outlined
                v-model="studentInfo.missionStatement"
                :label="$t('portfolio.missionStatement')"
                rows="3"
              ></v-textarea>
              <v-textarea
                counter="1000"
                dir="auto"
                :rules="[v => v.length <= 1000]"
                outlined
                v-model="studentInfo.careerGoals"
                :label="$t('portfolio.careerGoals')"
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="saveProfile">
            <v-icon>mdi-content-save</v-icon> {{ $t("save") }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="editDialog = false">{{ $t("cancel") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import NoImage from "@/assets/user.svg";
import InfoSection from "./infoSection.vue";
import SummarySection from "./summarySection.vue";
import profileImage from "./profileImage.vue";

export default {
  name: "PortfolioCard",
  components: {
    InfoSection,
    SummarySection,
    profileImage
  },
  data() {
    return {
      NoImage,
      editDialog: false,
      studentInfo: {},
      selectedPhotoFile: null,
      originalPhotoUrl: null,
      worksStatus: {
        workSampleCount: 0,
        achievementCount: 0,
        goalsCount: 0
      }
    };
  },
  created() {
    this.getUserStats();
    this.getProfile();
  },
  methods: {
    onPhotoSelected(file) {
      if (file && file instanceof File) {
        this.studentInfo.photoUrl = URL.createObjectURL(file);
      } else {
        this.studentInfo.photoUrl = this.originalPhotoUrl;
      }
    },
    getUserStats() {
      this.axios
        .get("WorkSample/GetStudentStatus/" + this.studentId)
        .then(response => {
          this.worksStatus = response.data.data;
        })
        .catch(error => {
          console.error("Error fetching portfolios:", error);
        });
    },
    getProfile() {
      this.axios
        .get("Account/GetStudentProfile?studentGuid=" + this.studentId)
        .then(response => {
          this.studentInfo = response.data.data;
          this.originalPhotoUrl = this.studentInfo.photoUrl || this.NoImage;
        })
        .catch(error => {
          console.error("Error fetching student profile:", error);
          //route to home
          this.$router.push({ path: "/" });
        });
    },
    saveProfile() {
      const formData = new FormData();
      formData.append("email", this.studentInfo.email);
      formData.append("phoneNumber", this.studentInfo.phoneNumber);
      formData.append("missionStatement", this.studentInfo.missionStatement);
      formData.append("careerGoals", this.studentInfo.careerGoals);
      if (this.selectedPhotoFile) {
        formData.append("photoFile", this.selectedPhotoFile);
      }

      this.axios
        .put("Account/UpdateStudentProfile", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.statusCode == 1) {
            this.editDialog = false;
            this.getProfile();
          }
        })
        .catch(error => {
          console.error("Error saving profile:", error);
        });
    }
  },
  computed: {
    studentId() {
      return this.$route.params.id;
    }
  }
};
</script>
